import { render, staticRenderFns } from "./DavissonGermerViz.vue?vue&type=template&id=c3b61800&scoped=true"
import script from "./DavissonGermerViz.vue?vue&type=script&lang=js"
export * from "./DavissonGermerViz.vue?vue&type=script&lang=js"
import style0 from "./DavissonGermerViz.vue?vue&type=style&index=0&id=c3b61800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b61800",
  null
  
)

export default component.exports